import { createSlice } from "@reduxjs/toolkit";

interface AtonState {
    users: any[];
}

const initialState: AtonState = {
    users: [],
};

export const atonSlice = createSlice({
    name: "aton",
    initialState,
    reducers: {
        setAtonUsers(state, action) {
            state.users = action.payload;
        },
    },
});

export const { setAtonUsers } = atonSlice.actions;
export const selectAtonUsers = (state: any) => state.aton.users;
export default atonSlice.reducer;
